/** Random ids for intents (`actionId`) and UI keys. Crypto-backed when available. */
export function randomToken(length = 16): string {
  const alphabet = 'abcdefghijklmnopqrstuvwxyz0123456789';
  const bytes = new Uint8Array(length);
  if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
    crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < length; i++) bytes[i] = Math.floor(Math.random() * 256);
  }
  let out = '';
  for (const b of bytes) out += alphabet[b % alphabet.length];
  return out;
}

/** A fresh idempotency key for a mutating intent. */
export function newActionId(): string {
  return `a_${Date.now().toString(36)}_${randomToken(10)}`;
}
